module.exports = __webpack_public_path__ + "img/2_3_1.6ce4538c.png";